import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    show: Boolean,
    invoiceId: Number,
    lockVersion: Number,
    contractorId: Number
  }

  connect() {
    if (this.showValue) {
      $(this.element).modal({ closable: false }).modal("show")
    }
  }

  async force() {
    const formData = new FormData()
    formData.append("contractor_assignment[contractor_id]", this.contractorIdValue)
    formData.append("contractor_assignment[lock_version]", this.lockVersionValue)
    const response = await fetch(`/panel/invoices/${this.invoiceIdValue}/contractor_assignments`, {
      method: "POST",
      headers: {
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
        "Accept": "text/vnd.turbo-stream.html"
      },
      body: formData
    })
    if (response.ok) {
      $(this.element).modal("hide")
    } else {
      alert("Wystąpił błąd podczas wymuszonego zapisu.")
    }
  }

  cancel() {
    $(this.element).modal("hide")
    window.location.reload()
  }
}
